;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "./styles.module.scss"
import Chairs from "../Chairs"

function YourGroupExampleScorecard() {
  return [
    <div className={styles["outer-container"]} key={"score-card-first"}>
      <div className={styles["inner-container"]}>
        <div className={styles["header"]}>Your Group</div>
        <div className={styles["bottom"]}>
          <div className={styles["stack"]}>
            <div className={styles["numbers"]}>8</div>
            <div className={styles["numbers"]}>1</div>
            <div className={styles["numbers"]}>1</div>
          </div>

          <div className={styles["divider"]}></div>

          <div className={styles["stack"]}>
            <div className={styles["words"]}>Confirmed seats</div>
            <div className={styles["words"]}>Pending seats</div>
            <div className={styles["words"]}>Available seats</div>
          </div>
        </div>
      </div>
    </div>,
    <div className={styles["arrow-down"]} key={"score-card-arrowd"}></div>,
    <div className={styles["chairs-container"]} key={"score-card-chairs"}>
      <Chairs />
    </div>,
  ]
}
export default YourGroupExampleScorecard
